// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31LOs","inner":"Form_inner__3WZAT","range":"Form_range__1-bJx","name":"Form_name__2axOk","actions":"Form_actions__kcrbM"};